Vue.component('ack-product-scrolling-content', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-product-scrolling-content',
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	props: {
		scrollingItems: {
			// :product-info
			type: Array,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: false,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		desHyperLink: {
			type: Object,
			required: false,
			default: () => ({
				hyperLink: '',
			}),
		},
		currentPageId: {
			type: String,
			required: false,
		},
	},
	computed: {
		// ...Vuex.mapGetters('shop', ['productList']),
		currentImgUrl() {
			return this.imgUrl;
		},
	},
	data() {
		return {
			imgUrl: null, // 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_V4_Printing_capacity.jpg?v=1700722392',
			// scrollingItems: [
			//     {
			//       title: 'A key that works everywhere',
			//       description: 'Auto-Unlock detects when you arrive and unlocks the door. Enable Auto-Lock to lock when the door closes.',
			//       image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/SOL_V4_Printing_capacity.jpg?v=1700722392',
			//     }
			//   ],
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
		isElementInViewport(el) {
			var rect = el.getBoundingClientRect();
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		},

		handleScroll() {
			let elementList = document.getElementsByClassName('product-scrolling-content-text');
			let imgUrl = null;
			for (let index = 0; index < elementList.length; index++) {
				const element = elementList[index];
				if (this.isElementInViewport(element)) {
					imgUrl = element.getAttribute('image-url');
				}
			}
			this.imgUrl = imgUrl;
		},
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	watch: {
		prop1: {
			handler() {},
			deep: false,
		},
	},
});
